(function () {
  class Jq3xModePanel extends HTMLElement {
    connectedCallback() {
      if (this.inited) return;
      this.inited = true;
      this.init();
    }

    disconnectedCallback() {
      this.destroy();
      this.inited = false;
    }

    init() {
      if (typeof Swiper === "undefined") {
        this.retry_count = (this.retry_count || 0) + 1;
        if (this.retry_count > 20) return;
        this.retry_timer = setTimeout(() => this.init(), 120);
        return;
      }

      this.main_el = this.querySelector("[data-jmp-main]");
      if (!this.main_el) return;

      const enable_autoplay = this.dataset.autoplay === "true";
      const autoplay_delay = Math.max(1, Number(this.dataset.autoplayDelay || 5)) * 1000;
      const reduce_motion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

      this.autoplay_enabled = enable_autoplay && !reduce_motion;

      this.main_swiper = new Swiper(this.main_el, {
        effect: "fade",
        fadeEffect: { crossFade: true },
        slidesPerView: 1,
        spaceBetween: 0,
        speed: reduce_motion ? 0 : 450,
        loop: true,
        allowTouchMove: true,
        autoHeight: true,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        autoplay:
          this.autoplay_enabled
            ? {
                delay: autoplay_delay,
                disableOnInteraction: false,
                pauseOnMouseEnter: true
              }
            : false,
        on: {
          init: (swiper) => {
            this.update_timeline(swiper.realIndex);
          },
          slideChange: (swiper) => {
            this.update_timeline(swiper.realIndex);
          }
        }
      });

      this.on_click = (event) => {
        if (!this.main_swiper) return;

        const dot = event.target.closest("[data-jmp-dot]");
        if (dot) {
          const index = Number(dot.getAttribute("data-jmp-dot"));
          if (Number.isFinite(index)) {
            this.go_to_slide(index);
          }
          return;
        }

        if (event.target.closest("[data-jmp-prev]")) {
          this.main_swiper.slidePrev();
          return;
        }

        if (event.target.closest("[data-jmp-next]")) {
          this.main_swiper.slideNext();
        }
      };

      this.addEventListener("click", this.on_click);
      this.bind_visibility();
    }

    go_to_slide(index) {
      if (!this.main_swiper) return;

      if (typeof this.main_swiper.slideToLoop === "function") {
        this.main_swiper.slideToLoop(index);
      } else {
        this.main_swiper.slideTo(index);
      }

      if (
        this.autoplay_enabled &&
        this.main_swiper.autoplay &&
        typeof this.main_swiper.autoplay.start === "function"
      ) {
        this.main_swiper.autoplay.start();
      }
    }

    update_timeline(index) {
      this.querySelectorAll("[data-jmp-dot]").forEach((dot) => {
        const is_active = Number(dot.getAttribute("data-jmp-dot")) === index;
        dot.classList.toggle("is-active", is_active);
        if (is_active) {
          dot.setAttribute("aria-current", "true");
        } else {
          dot.removeAttribute("aria-current");
        }
      });
    }

    bind_visibility() {
      if (!this.autoplay_enabled || !this.main_swiper || !this.main_swiper.autoplay) return;
      if (typeof IntersectionObserver === "undefined") return;

      this.io = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          if (!this.main_swiper || !this.main_swiper.autoplay) return;
          if (entry.isIntersecting) {
            this.main_swiper.autoplay.start();
          } else {
            this.main_swiper.autoplay.stop();
          }
        },
        { threshold: 0.25 }
      );
      this.io.observe(this);
    }

    destroy() {
      if (this.retry_timer) {
        clearTimeout(this.retry_timer);
        this.retry_timer = null;
      }

      if (this.io) {
        this.io.disconnect();
        this.io = null;
      }

      if (this.on_click) {
        this.removeEventListener("click", this.on_click);
        this.on_click = null;
      }

      if (this.main_swiper) {
        this.main_swiper.destroy(true, true);
        this.main_swiper = null;
      }
    }
  }

  function mount_jq3x_mode_panel(root) {
    if (!root) return;
    const panels = root.matches("jq3x-mode-panel")
      ? [root]
      : Array.from(root.querySelectorAll("jq3x-mode-panel"));

    panels.forEach((panel) => {
      if (panel.inited) {
        panel.disconnectedCallback();
        panel.connectedCallback();
      }
    });
  }

  if (!customElements.get("jq3x-mode-panel")) {
    customElements.define("jq3x-mode-panel", Jq3xModePanel);
  }

  document.addEventListener("shopify:section:load", (event) => {
    mount_jq3x_mode_panel(event.target);
  });

  document.addEventListener("shopify:block:select", (event) => {
    const panel = event.target.closest("jq3x-mode-panel");
    if (!panel || !panel.main_swiper) return;

    const slide_el = event.target.closest(".jq3x-mode__slide");
    if (!slide_el) return;

    const slides = Array.from(
      panel.querySelectorAll(".jq3x-mode__slide:not(.swiper-slide-duplicate)")
    );
    const index = slides.indexOf(slide_el);

    if (index >= 0) {
      panel.go_to_slide(index);
    }
  });
})();
